import React from "react";
import DataTable from "@/components/Datatable/Datatable";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { AdminCatalogCategory } from "../../api/fetchCatalogCategories";
import { useCatalogCategoryList } from "../../hooks/useCatalogCategoryList";
import CatalogCategoryDialog from "../CatalogCategoryDialog/CatalogCategoryDialog";
import ConfirmDeleteDialog from "../ConfirmDeleteDialog/ConfirmDeleteDialog";

const CatalogCategoryList: React.FC = () => {
  const {
    categories,
    totalCount,
    loading,
    pagination,
    setPagination,
    columns,
    dialogState,
    openCreateDialog,
    closeDialog,
    handleSave,
    deleteDialogState,
    closeDeleteDialog,
    handleConfirmDelete,
    isDeleting,
  } = useCatalogCategoryList();

  return (
    <MainPageWrapper
      actions={
        <Button
          className="flex items-center gap-1"
          onClick={openCreateDialog}
          size="sm"
        >
          <Plus className="w-4 h-4" />
          New Category
        </Button>
      }
      subtitle="Group catalog entries on the member page"
      title="Catalog Categories"
    >
      <div className="relative">
        <DataTable<AdminCatalogCategory>
          columns={columns}
          data={categories}
          loading={loading}
          noDataMessage="No categories found. Create one to get started."
          onPageChange={(newPageIndex, newPageSize) =>
            setPagination({ pageIndex: newPageIndex, pageSize: newPageSize })
          }
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          rowKeyExtractor={(item) => item.id}
          totalCount={totalCount}
        />
      </div>

      <CatalogCategoryDialog
        category={dialogState.category}
        isOpen={dialogState.isOpen}
        isSaving={dialogState.isSaving}
        onClose={closeDialog}
        onSave={handleSave}
      />

      <ConfirmDeleteDialog
        description={`Are you sure you want to delete "${deleteDialogState.categoryName}"? Categories with products assigned cannot be deleted.`}
        isOpen={deleteDialogState.isOpen}
        isPending={isDeleting}
        onClose={closeDeleteDialog}
        onConfirm={handleConfirmDelete}
        title="Delete category"
      />
    </MainPageWrapper>
  );
};

export default CatalogCategoryList;
